import { useParams } from "react-router-dom";
import { FormServiceTrakingLayout } from "../layouts";
import { useEffect, useState } from "react";
import { adminAPI } from "../../api/adminAPI";
import { useSelector } from "react-redux";
import { Spinner } from "../../ui";

export const EditServicesPage = () => {
  const { jwt } = useSelector((state) => state.auth);
  const { id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [services, setService] = useState({});

  const getService = async () => {
    const headers = {
      "x-token": jwt,
    };
    const resp = await adminAPI
      .get(`/services/${id}`, { headers })
      .catch(({ response }) => response);
    if (resp.status !== 200) return;
    const { data } = resp.data;
    setService(data);
    setLoading(true);
  };
  useEffect(() => {
    getService();
  }, []);

  return (
    <>
      {isLoading ? (
        <FormServiceTrakingLayout isEditMode={true} dataToEdit={services} />
      ) : (
        <Spinner />
      )}
    </>
  );
};
